export default {
  'Please select an output format': '출력 형식을 선택하십시오.',
}